import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';
import { AcessoService } from './acesso.service';
import { chamadaEntrada, urlApi } from './acesso-http';

export const CABECALHO_TOKEN_RENOVADO = 'X-Acesso-Token';

export const acessoInterceptor: HttpInterceptorFn = (req, next) => {
  const document = inject(DOCUMENT);
  const origem = document.location.origin;
  if (!urlApi(req.url, origem)) return next(req);
  const acesso = inject(AcessoService);
  const router = inject(Router);
  // A entrada define o usuário; um token anterior nunca a acompanha.
  const token = chamadaEntrada(req.url, origem) ? null : acesso.obterToken();
  const enviada = token
    ? req.clone({ withCredentials: true, setHeaders: { Authorization: `Bearer ${token}` } })
    : req.clone({ withCredentials: true });
  return next(enviada).pipe(
    tap(evento => {
      if (!token || !(evento instanceof HttpResponse)) return;
      const renovado = evento.headers.get(CABECALHO_TOKEN_RENOVADO);
      if (renovado) acesso.renovarToken(renovado);
    }),
    catchError((erro: HttpErrorResponse) => {
      if (erro.status === 401) {
        acesso.limparContexto();
        void router.navigate(['/acesso']);
      }
      return throwError(() => erro);
    })
  );
};
